var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.wrapper,{tag:"component",class:_vm.classObject,attrs:{"to":_vm.to,"replace":_vm.replace,"append":_vm.append,"exact":_vm.exact,"href":_vm.href,"target":_vm.target}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }